import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { Modal, Button, Popconfirm } from "antd"; // Import Popconfirm for confirmation dialog
import { base_url } from "../utils/baseUrl";
import "./Attributes.css"; // Import custom CSS for button styles

const Attributes = () => {
    const [attributes, setAttributes] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [currentAttribute, setCurrentAttribute] = useState({ id: null, name: "" });

    // Fetch attributes from the backend
    useEffect(() => {
        const fetchAttributes = async () => {
            try {
                const response = await axios.get(`${base_url}/api/attributes/getAllAttributes`);
                setAttributes(response.data);
            } catch (error) {
                console.error("Error fetching attributes:", error);
                toast.error("Failed to load attributes");
            }
        };
        fetchAttributes();
    }, []);

    // Open modal for adding or editing an attribute
    const openModal = (attribute = null) => {
        if (attribute) {
            setModalTitle("Edit Attribute");
            setCurrentAttribute({ id: attribute.attribute_id, name: attribute.name });
        } else {
            setModalTitle("Add Attribute");
            setCurrentAttribute({ id: null, name: "" });
        }
        setIsModalOpen(true);
    };

    // Handle saving the attribute (add or edit)
    const handleSave = async () => {
        if (!currentAttribute.name.trim()) {
            toast.error("Attribute name is required");
            return;
        }

        try {
            if (currentAttribute.id) {
                // Edit existing attribute
                await axios.put(`${base_url}/api/attributes/${currentAttribute.id}`, {
                    name: currentAttribute.name,
                });
                setAttributes((prev) =>
                    prev.map((attr) =>
                        attr.attribute_id === currentAttribute.id
                            ? { ...attr, name: currentAttribute.name }
                            : attr
                    )
                );
                toast.success("Attribute updated successfully!");
            } else {
                // Add new attribute
                const response = await axios.post(`${base_url}/api/attributes`, {
                    name: currentAttribute.name,
                });
                setAttributes((prev) => [
                    ...prev,
                    { attribute_id: response.data.attributeId, name: currentAttribute.name },
                ]);
                toast.success("Attribute added successfully!");
            }
            setIsModalOpen(false);
        } catch (error) {
            console.error("Error saving attribute:", error);
            toast.error("Failed to save attribute.");
        }
    };

    const handleDelete = async (attributeId) => {
        try {
            await axios.delete(`${base_url}/api/attributes/${attributeId}`);
            setAttributes((prev) => prev.filter((attr) => attr.attribute_id !== attributeId));
            toast.success("Attribute deleted successfully!");
        } catch (error) {
            console.error("Error deleting attribute:", error);
            toast.error("Failed to delete attribute.");
        }
    };

    return (
        <div>
            <h3 className="mb-4 title">Attributes</h3>
            <Button
                type="primary"
                onClick={() => openModal()}
                className="attribute-custom-button mb-4"
            >
                Add Attribute
            </Button>
            <table className="table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Attribute Name</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {attributes.map((attribute, index) => (
                        <tr key={attribute.attribute_id}>
                            <td>{index + 1}</td>
                            <td>{attribute.name}</td>
                            <td>
                                <Button
                                    type="primary"
                                    onClick={() => openModal(attribute)}
                                    className="attribute-custom-button"
                                    style={{ marginRight: "10px" }}
                                >
                                    Edit
                                </Button>
                                <Popconfirm
                                    title="Are you sure you want to delete this attribute?"
                                    onConfirm={() => handleDelete(attribute.attribute_id)}
                                    okText="Yes"
                                    cancelText="No"
                                    okButtonProps={{ className: "attribute-ok-button" }}
                                    cancelButtonProps={{ className: "attribute-custom-button" }}
                                >
                                    <Button
                                        type="danger"
                                        className="attribute-custom-button"
                                    >
                                        Delete
                                    </Button>
                                </Popconfirm>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Modal for Add/Edit Attribute */}
            <Modal
                title={modalTitle}
                open={isModalOpen}
                onOk={handleSave}
                onCancel={() => setIsModalOpen(false)}
                okText={<span className="custom-button-text">Save</span>}
                cancelText="Cancel"
                okButtonProps={{ className: "attribute-custom-button" }}
            >
                <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Attribute Name"
                    value={currentAttribute.name}
                    onChange={(e) =>
                        setCurrentAttribute((prev) => ({ ...prev, name: e.target.value }))
                    }
                />
            </Modal>
        </div>
    );
};

export default Attributes;
